import { setLocale } from 'yup';

export function configureYup() {
    setLocale({
        mixed: {
            required: 'O campo está vazio. Por favor, preencha corretamente.',
        },
        string: {
            email: 'Email inválido.',
            url: 'Url inválida.',
            min: (c) => `Campo deve ter pelo menos ${c.min} caracteres.`,
            max: (c) => `Campo deve ter no máximo ${c.max} caracteres.`,
        },
        number: {
            positive: 'Deve ser maior que zero.',
            min: (c) => `Deve ser maior que ${c.min}.`,
        },
        boolean: {
            isValue: 'O campo está vazio. Por favor, preencha corretamente.',
        },
    });
}
